module.exports = __webpack_public_path__ + "img/arrow-right-white.9df29bb8.svg";